Alpine.store('customer', {
    item: {},
    subscription: {},

    init() {
        window.addEventListener('set-customer-main-event', ({ detail }) => {
            Object.assign(this.subscription, detail[0]);
        });

        window.addEventListener('customer-updated', ({ detail }) => {
            Object.assign(this.item, detail[0]);

            if (this.item.first_name && this.item.last_name) {
                this.item.name = [this.item.first_name, this.item.last_name].join(' ');
            }
        });
    },

    hasAllImagePackage(){
        return this.item?.has_all_images;
    },

    customerIsPrepaid(){
        return this.item?.is_prepaid;
    },

    hasInfo(){
        return this.item?.name
            && this.item?.email;
    },
});
